import { render, staticRenderFns } from "./AppTitleSection.vue?vue&type=template&id=4627abe5&scoped=true"
import script from "./AppTitleSection.vue?vue&type=script&lang=js"
export * from "./AppTitleSection.vue?vue&type=script&lang=js"
import style0 from "./AppTitleSection.vue?vue&type=style&index=0&id=4627abe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4627abe5",
  null
  
)

export default component.exports